import JelWorkspace from '@/store/classes/jelWorkspace';

const jelWorkspace = new JelWorkspace({
  module: 'promo',
  refreshMinProd: process.env.VUE_APP_STORE_PROMO_REFRESH_MIN,
  refreshMinDev: process.env.VUE_APP_STORE_DEV_REFRESH_MIN,
});

const state = {
  ...jelWorkspace.state,
  codePromo: '',
  montant: 0,
  promo: null,
  lienModalites: null,
  lastUpdate: '',
  isPromoNotValid: false,
};
const getters = {
  ...jelWorkspace.getters,

  getLastUpdate: (state) => {
    return state.lastUpdate;
  },
};
const actions = {
  ...jelWorkspace.actions,

  reset({ commit }) {
    commit('RESET');
  },
  setLastUpdate: ({ commit, state }, value) => {
    commit('SET_LASTUPDATE', value);
    return state.lastUpdate;
  },
};
const mutations = {
  ...jelWorkspace.mutations,

  async INIT(state) {
    if (!state.isLoaded) {
      this.commit(`${state.module}/INTERNAL_INIT`);
    }
  },

  RESET(state) {
    // Merge rather than replace so we don't lose observers
    // https://github.com/vuejs/vuex/issues/1118
    state.codePromo = '';
    state.montant = 0;
    state.lastUpdate = '';
    state.promo = null;
    state.isPromoNotValid = false;
  },

  SET_CODE_PROMO(state, value) {
    state.codePromo = value;
  },
  SET_LIEN_MODALITES(state, value) {
    state.lienModalites = value;
  },
  SET_MONTANT_PROMO(state, value) {
    state.montant = value;
  },
  SET_PROMO(state, value) {
    state.promo = value;
  },
  SET_LASTUPDATE: (state, value) => {
    state.lastUpdate = value;
  },
  SET_IS_PROMO_NOT_VALID(state, value) {
    state.isPromoNotValid = value;
  },
};

export default {
  namespaced: true,
  state,
  getters,
  actions,
  mutations,
};
